import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { withBasePath } from '_config/basePath';
import { prepareAuthHeaders } from './auth';


interface Reference {
    id: string;
    unique_id: string;
    user_id: string;
    group_id: string;
    fields: any;
}


export const myRefApi = createApi({
    reducerPath: 'myRefApi',
    baseQuery: fetchBaseQuery({
        baseUrl: withBasePath(''),
        prepareHeaders: prepareAuthHeaders,
        credentials: 'include',
    }),
    endpoints: (builder) => ({
        getMyRef: builder.mutation<Reference[], any>({
            query: (params = {}) => ({
                url: '/api/references',
                method: 'GET',
                params
            }),
            transformResponse: (response: any) => {
                return response.references;
            }
        }),
        createMyRef: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references',
                method: 'PUT',
                body
            })
        }),
        updateMyRef: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references',
                method: 'PATCH',
                body
            })
        }),
        deleteMyRef: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references',
                method: 'DELETE',
                body
            })
        })

    })
});

export const { useGetMyRefMutation, useCreateMyRefMutation, useDeleteMyRefMutation, useUpdateMyRefMutation } = myRefApi;


